<template>
  <q-banner v-if="showBanner" class="bg-grey-9 text-white fixed-bottom z-top">
    We use cookies to collect anonymous analytics data to help us improve our website and understand useage. You can choose to accept or decline these cookies.
    <template v-slot:action>
      <q-btn label="Accept" color="white"  text-color="black" @click="accept" />
      <q-btn flat label="Decline" @click="decline" />
    </template>
  </q-banner>
</template>

<script setup>
// @ts-nocheck
import { ref, onMounted } from 'vue'
import { LocalStorage } from 'quasar'

const storageKey = getCookieConsentKey()
const showBanner = ref(false)

function getCookieConsentKey() {
  const base = import.meta.env.BASE_URL || '/'
  const suffix = base === '/' || base === ''
    ? ''
    : '-' + base.replace(/^\/+|\/+$/g, '').replace(/\//g, '-')
  return `cookie-consent${suffix}`
}

onMounted(() => {
  const storedConsent = LocalStorage.getItem(storageKey)
  showBanner.value = storedConsent !== 'accepted' && storedConsent !== 'declined'
})

const accept = () => {
  LocalStorage.set(storageKey, 'accepted')
  showBanner.value = false
  // Initialize Google Analytics
  initGoogleAnalytics()


}

const initGoogleAnalytics = () => {
  if (!window.gtag) {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-GGFNTR0EV9'
    document.head.appendChild(script)
    
    window.dataLayer = window.dataLayer || []
    window.gtag = function() { dataLayer.push(arguments) }
    window.gtag('js', new Date())
    window.gtag('config', 'G-GGFNTR0EV9')
    
    // Send initial events
    setTimeout(() => {
      window.gtag('event', 'page_view')
      window.gtag('event', 'cookie_consent', {
        event_category: 'consent',
        event_label: 'accepted'
      })
    }, 100)
  }
}



const decline = () => {
  LocalStorage.set(storageKey, 'declined')
  showBanner.value = false
  // Analytics won't be loaded at all
}
</script>